import { render, staticRenderFns } from "./cardInternationalSmsProduct.vue?vue&type=template&id=e90eb668&scoped=true&"
import script from "./cardInternationalSmsProduct.vue?vue&type=script&lang=js&"
export * from "./cardInternationalSmsProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90eb668",
  null
  
)

export default component.exports